import {Component} from '@angular/core';

@Component({
  selector: 'gp-not-found',
  templateUrl: './not-found.component.html',
  styles: [`
    :host {
      height: calc(100vh - 66px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .wrapper h4 {
      margin: 2rem 0 0 0;
    }

    @media (max-width: 358px) {
      .wrapper img {
        display: none;
      }

      .wrapper h4 {
        margin: 0;
      }
    }
  `]
})

export class NotFoundComponent {

}
